module.exports = __webpack_public_path__ + "static/media/monitor.a9b65935.png";